<template>
   <div id="printItem" v-show="isPrintingItem">
    <report-header>
      <h2>{{ staffName }} Garnishment</h2>
    </report-header>
    <v-container>
      <table width="100%">
        <tr>
          <th>Agency Name</th>
          <td>
            {{ items.agency }}
          </td>
        </tr>
        <tr>
          <th>Garnishment Type</th>
          <td>
            {{ items.type }}
          </td>
        </tr>
        <tr>
          <th colspan="2">
            <h3 class="pt-6">Payment Information</h3>
            <hr />
          </th>
        </tr>
        <tr>
          <th>Case/Account Number</th>
          <td>
            {{ items.account }}
          </td>
        </tr>
        <tr>
          <th>Additional Number</th>
          <td>
            {{ items.additional }}
          </td>
        </tr>
        <tr>
          <th>Court Date</th>
          <td>
            {{ items.courtDate }}
          </td>
        </tr>
        <tr>
          <th>Plaintiff Name</th>
          <td>
            {{ items.plaintiff }}
          </td>
        </tr>
        <tr>
          <th>Recipient Name</th>
          <td>
            {{ items.recipient }}
          </td>
        </tr>
        <tr>
          <th>Amount</th>
          <td>
            {{ items.amount }}
          </td>
        </tr>
        <tr>
          <th>Notes</th>
          <td>
            {{ items.notes }}
          </td>
        </tr>
        <tr>
          <th>Document/s</th>
          <td>
            <v-col
              cols="12"
              sm="12"
              md="12"
              v-for="(doc, index) in items.document"
              :key="index"
            >
              <div v-if="doc.ext != 'pdf'">
                <v-img max-height="480" max-width="550" :src="doc.aws"></v-img>
              </div>
              <div v-if="doc.ext == 'pdf'">
                <a :href="doc.aws">Document {{ index + 1 }}</a>
              </div>
            </v-col>
          </td>
        </tr>
        <tr>
          <th>Status</th>
          <td>
            {{ items.status }}
          </td>
        </tr>
      </table>
    </v-container>
  </div>
</template>

<script>
import ReportHeader from "@/components/Report/ReportHeader.vue";

export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
    staffName: {
      type: String,
      default: "",
    },
    isPrintingItem: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ReportHeader,
  },
};
</script>
